import { defineStore } from "pinia";
import verConfig from "@/utils/config";
import { GET_INITCOINDATA, NEW_GET_INITCOINCHARTDATA, GET_ASSETSLIST } from "@/api";
import { useIncrease, setStorage, formatMoney, getStorage, socket as ws } from "@/utils";
import { nextTick } from "vue";

const state = () => ({
  socket: null,
  heartBeatInterval: null,
  dayData: [],
  data: [],
  kineData: [],
  code: getStorage('tradeItem') && JSON.parse(getStorage('tradeItem')).code,
  oldKlineData: [],
  assetsList: [],
  timeNum: 0,
  newKlineData: {},
  errorNum: 0
})

export const useCoinStore = defineStore('coins', {
  state,
  getters: {
    coins() {
      if (!this.data.length) {
        this.init();
      }
      return this.data;
    },
    coinItem() {
      return (code) => {
        let item = {};
        if (!code) {
          item = this.data[0] || {};
        } else {
          item = this.data.find((a) => a.code === code) || {};
        }
        return item;
      }
    },
    searchCoins() {
      return (_title) => {
        if (!_title) {
          return this.data;
        }
        return this.data.filter(item => item.title.toUpperCase().includes(_title.toUpperCase()));
      }
    },
    newSearchCoins() {
      return (_title) => {
        if (!_title) {
          return this.data;
        }
        const regexString = _title.split('').map(char => `(.*${char})`).join('');
        const regex = new RegExp(`^${regexString}`, 'i');
        return this.data.filter(item => regex.test(item.title));
      }
    },
    getkineData() {
      return this.kineData;
    },
    getCode() {
      return this.code
    },
    getoldKlineData() {
      return this.oldKlineData
    },
    getAssetsList() {
      return this.assetsList
    },
    getTimeNum() {
      return this.timeNum
    },
    getNewKlineData() {
      return this.newKlineData
    }
  },
  actions: {
    async init() {
      if (this.socket) {
        this.close();
      }
      this.getKline();
      try {
        const { data } = await GET_INITCOINDATA({ time: 'd' });
        
        if (data.length != 0) {
          const modifiedData = data.map(item => {
            const { max, min, open, ...rest } = item;
            const modifiedItem = {
              dmax: max,
              dmin: min,
              dopen: open,
              ...rest
            };
            return modifiedItem;
          });
          this.data = [...modifiedData]
          if (!getStorage('kline_code_coin')) {
            setStorage('kline_code_coin', JSON.stringify({
              ...modifiedData[0], title: modifiedData[0].title, code: modifiedData[0].code
            }))
          }
        } else {
          this.data = [];
        }
        this.getAssetslist();
        this.connect();
      } catch (e) {
        console.error("get data error", e)
      }
    },
    connect() {
      if (this.socket) {
        this.close();
      }
      this.socket = ws(verConfig.wsUrl)
      this.socket.onOpen(() => this.onOpen());
      this.socket.onMessage((res) => this.onMessage(res))
      // this.socket.onError(() => this.onError())
    },
    send(_data) {
      let data = {};
      const _this = this;
      if (typeof _data === "object") {
        data = JSON.stringify(_data);
      } else {
        data = _data;
      }
      _this.socket && _this.socket.send(data).then(() => { }).catch((e) => {
        _this.clearHearBeat();
        _this.socket.disconnect();
        _this.socket = null;
        _this.connect();
      })
    },
    clearHearBeat() {
      this.heartBeatInterval && clearInterval(this.heartBeatInterval)
      this.heartBeatInterval = null;
    },
    close() {
      this.clearHearBeat();
      const _this = this;
      this.socket.onClose(() => {
        _this.clearHearBeat();
        _this.socket = null;
        _this.socket.disconnect();
      })
    },
    onOpen() {
      this.clearHearBeat();
      console.log('连接成功');
      this.heartBeatInterval = setInterval(() => {
        this.send({
          act: 'online'
        })
      }, 10000)
    },
    setTimeNum() {
      let num = Math.floor(Date.now() / 1000) % 1000000 * 1000 + Math.floor(Math.random() * (999 - 100 + 1)) + 100;
      this.timeNum = num;
    },
    onMessage(res) {
      const data = res.data || "";
      this.setTimeNum();
      try {
        const _res = JSON.parse(data);
        const _data = [...this.data];
        let _klineData = [...this.kineData];
        let _assetsList = (this.assetsList && [...this.assetsList]) || [];
        let _newKlineData = JSON.parse(JSON.stringify(this.newKlineData));
        for (const key in _res) {
          if (Object.hasOwnProperty.call(_res, key)) {
            const values = _res[key];
            const _index = this.data.findIndex(a => a.code === key);
            if (_index !== -1) {
              const _item = this.data[_index];
              _item.increase = useIncrease(_item);
              _data[_index] = { ..._item, ...values, count: (_item.count || 0) - -(values.count || 0) };
            }
          }
        }
        _data.forEach(item => {
          item.newMoney = formatMoney(item.price, item.decimal)
        })
        this.data = [..._data];
        _assetsList.forEach((item, index) => {
          let obj = _data.find(val => val.title == item.title);
          item.decimal = obj?.decimal || 2;
          if (item.title == 'USDT') {
            item.usdMoney = Number(item?.coin_amount) || 0
          } else {
            item.usdMoney = ((obj?.price && Number(obj?.price)) * (item?.coin_amount && Number(item?.coin_amount))) || 0;
          }
        });
        this.assetsList = [..._assetsList]

        const _keys = Object.keys(_newKlineData);

        _keys.forEach((item, index) => {
          const setData = _data.find(val => val.code == item);
          let obj = {
            open: Number(setData?.open),
            timestamp: Number(setData?.id || 0)
          }
          let lastIndex = _newKlineData[item].length;
          let last = _newKlineData[item][lastIndex - 1];

          if (Object.hasOwnProperty.call(_res, item)) {
            if (last.timestamp === obj.timestamp) {
              _newKlineData[item][lastIndex - 1] = obj
            } else {
              const [, ...rest] = _newKlineData[item];
              _newKlineData[item] = [...rest, { ...obj }]
            }
          }
        })
        this.newKlineData = _newKlineData;
        const setData = _data.find(item => item.code == this.code);
        let obj = {
          open: Number(setData?.open),
          close: Number(setData?.price),
          high: Number(setData?.max),
          low: Number(setData?.min),
          timestamp: Number(setData?.id || 0) * 1000
        }
        const lastData = _klineData[_klineData.length - 1];

        if (lastData?.timestamp == obj.timestamp) {
          _klineData[_klineData.length - 1] = obj;
        } else {
          _klineData = [..._klineData, { ...obj }]
        }
        this.kineData = _klineData;
        
        return _res;
      } catch (e) {
        console.error("Data Error", e, res);
        return res;
      }
    },
    onError() {
      this.errorNum += 1;
      if (this.errorNum < 6) {
        let timer = setTimeout(() => {
          this.clearHearBeat();
          this.connect();
          clearTimeout(timer)
        }, 3000)
      }
    },
    onClose() {
      console.error("websocket error");
    },
    async getKline() {
      const res = await NEW_GET_INITCOINCHARTDATA({ len: 20, time: 'i', });
      let arr = {};
      let keys = Object.keys(res.data)
      keys.forEach(item => {
        arr[item] = this.newItem(res.data[item].item_price);
      })
      this.newKlineData = arr;
    },
    newItem(data) {
      const newArr = data.map(item => {
        let obj = JSON.parse(item);
        return {
          open: Number(obj[0]),
          timestamp: Number(obj[5])
        }
      })
      return newArr.slice().reverse()

    },
    countItem(data) {
      const newArr = data.map(item => {
        let obj = JSON.parse(item)
        return {
          open: Number(obj[0]),
          close: Number(obj[1]),
          high: Number(obj[2]),
          low: Number(obj[3]),
          timestamp: Number(obj[5]) * 1000
        }
      })
      return newArr.slice().reverse()
    },
    setCode(code) {
      return this.code = code;
    },
    async getAssetslist() {
      try {
        const { data } = await GET_ASSETSLIST()
        const newData = data && Object.values(data)
        this.assetsList = newData;
      } catch (error) {
        console.error(error);
      }
    }
  }
})